<script>
  import { scaleLinear } from "d3-scale";
  import { fly } from "svelte/transition";

  export let points;
  export let yTicks;
  export let yLabel;
  const padding = { top: 20, right: 0, bottom: 20, left: 25 };

  export let width;
  export let height;
  export let barColor;

  function formatMobile(tick) {
    return "'" + tick.toString().slice(-2);
  }
  let selectedBar = -1;
  const onSelected = (id) => {
    selectedBar = id;
  };

  $: xScale = scaleLinear()
    .domain([0, points.length])
    .range([padding.left, width - padding.right]);

  $: yScale = scaleLinear()
    .domain([0, Math.max.apply(null, yTicks)])
    .range([height - padding.bottom, padding.top]);

  $: innerWidth = width - (padding.left + padding.right);
  $: barWidth = (innerWidth / points.length) * 0.6;
</script>

<div
  class="chart unselectable"
  bind:clientWidth={width}
  bind:clientHeight={height}
>
  <svg>
    <!-- y axis -->
    <g class="axis y-axis">
      {#each yTicks as tick}
        <g class="tick tick-{tick}" transform="translate(0, {yScale(tick)})">
          <line x2="100%" />
          <text y="-4"
            >{tick}
            {tick === yTicks[yTicks.length - 1] ? " " + yLabel : ""}</text
          >
        </g>
      {/each}
    </g>

    <!-- x axis -->
    <g class="axis x-axis">
      {#each points as point, i}
        <g class="tick" transform="translate({xScale(i)},{height})">
          <text x={barWidth / 2} y="-4"
            >{width > 380 ? point.x : formatMobile(point.x)}</text
          >
        </g>
      {/each}
    </g>

    <g class="bars">
      {#each points as point, i}
        <rect
          x={xScale(i) + 2}
          y={yScale(point.y)}
          width={barWidth - 4}
          height={yScale(0) - yScale(point.y)}
          style="fill: {barColor}"
          on:mouseenter={() => onSelected(i)}
          on:mouseleave={() => onSelected(-1)}
        />
        {#if i == selectedBar}
          <text
            style="font-size: 0.725em;"
            x={xScale(i) + 2 + (barWidth - 4) / 2}
            y={yScale(point.y) - 4}
            text-anchor="middle"
            transition:fly={{ y: -20, duration: 500 }}>{point.y}</text
          >
        {/if}
      {/each}
    </g>
  </svg>
</div>

<style>
  .chart {
    width: 100%;
    max-width: 500px;
    margin: 0 auto;
  }

  svg {
    position: relative;
    width: 100%;
    height: 200px;
  }

  .tick {
    font-size: 0.725em;
    font-weight: 200;
  }

  .tick line {
    stroke: #e2e2e2;
    stroke-dasharray: 2;
  }

  .tick text {
    fill: #ccc;
    text-anchor: start;
  }

  .tick.tick-0 line {
    stroke-dasharray: 0;
  }

  .x-axis .tick text {
    text-anchor: middle;
  }

  .bars rect {
    stroke: none;
    opacity: 0.65;
    transition: 0.1s ease-out;
  }
  .bars rect:hover {
    opacity: 1;
  }
  .bars text {
    fill: #ccc;
  }
</style>
